import { render, staticRenderFns } from "./TabelaCadastros.vue?vue&type=template&id=aa25a9bc&scoped=true"
import script from "./TabelaCadastros.vue?vue&type=script&lang=js"
export * from "./TabelaCadastros.vue?vue&type=script&lang=js"
import style0 from "./TabelaCadastros.vue?vue&type=style&index=0&id=aa25a9bc&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "aa25a9bc",
  null
  
)

export default component.exports